export default "<a class=\"btn btn-default btn-xs\" ng-click=\"ctrl.copy()\"><span class=\"fa fa-fw fa-copy\"></span> Copy To A New Layout</a>\n\n";